const colors = {
  black: '#16171d',
  blue: '#005fff',
  darkGray: '#181920',
  gray: '#ECEDF2',
  green: '#2EC87B',
  lavender: '#848EA9',
  offWhite: '#F7F7F9',
  orange: '#F39C41',
  purple: '#7741F3',
  red: '#F34141',
  slate: '#1c1d27',
  teal: '#41E9F3',
  trueBlack: '#000000',
  white: '#ffffff',
  yellow: '#F3CC41',
}

colors.shadow = colors.trueBlack

colors.success = colors.green
colors.info = colors.blue
colors.error = colors.red
colors.warning = colors.orange

export default colors
